/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Demo_DescriptionInputs */

const en_mcp_demo_description = /** @type {(inputs: Mcp_Demo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your AI to send what you're reading. Listening adds it to your library as audio, ready to play. No copying, no uploading.`)
};

const es_mcp_demo_description = /** @type {(inputs: Mcp_Demo_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pide a tu IA que envíe lo que estás leyendo. Listening lo añade a tu biblioteca como audio, listo para escuchar. Sin copiar ni subir nada.`)
};

/**
* | output |
* | --- |
* | "Ask your AI to send what you're reading. Listening adds it to your library as audio, ready to play. No copying, no uploading." |
*
* @param {Mcp_Demo_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_demo_description = /** @type {((inputs?: Mcp_Demo_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Demo_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_demo_description(inputs)
	return en_mcp_demo_description(inputs)
});